import { getCoordinatorApi } from "@/lib/api";

/**
 * Revoke a member's org-level binding (`DELETE /orgs/{org}/members/{account_id}`).
 * This removes the org role only; the account stays an org member via its projects.
 */
export const removeOrgMember = async ({
  organizationId,
  accountId,
}: {
  organizationId: string;
  accountId: string;
}): Promise<void> => {
  const client = getCoordinatorApi({ organizationId });
  await client.delete(`/members/${accountId}`);
};
